'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metadata = require('libphonenumber-js/metadata.min');

var _metadata2 = _interopRequireDefault(_metadata);

var _default = require('../locale/default');

var _default2 = _interopRequireDefault(_default);

var _InternationalIcon = require('./InternationalIcon');

var _InternationalIcon2 = _interopRequireDefault(_InternationalIcon);

var _PropTypes = require('./PropTypes');

var _PhoneInputNative = require('./PhoneInputNative');

var _PhoneInputNative2 = _interopRequireDefault(_PhoneInputNative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhoneInputNativeDefaultMetadata = (_temp2 = _class = function (_Component) {
	_inherits(PhoneInputNativeDefaultMetadata, _Component);

	function PhoneInputNativeDefaultMetadata() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, PhoneInputNativeDefaultMetadata);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNativeDefaultMetadata.__proto__ || Object.getPrototypeOf(PhoneInputNativeDefaultMetadata)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
			return _this.input = ref;
		}, _this.render = function () {
			return _react2.default.createElement(_PhoneInputNative2.default, _extends({ ref: _this.storeInputRef }, _this.props));
		}, _this.focus = function () {
			return _this.input.focus();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	return PhoneInputNativeDefaultMetadata;
}(_react.Component), _class.propTypes = {
	metadata: _PropTypes.metadata.isRequired,
	labels: _PropTypes.labels.isRequired,
	internationalIcon: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
	metadata: _metadata2.default,
	labels: _default2.default,
	internationalIcon: _InternationalIcon2.default
}, _temp2);
exports.default = PhoneInputNativeDefaultMetadata;
//# sourceMappingURL=PhoneInputNativeDefaultMetadata.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/commonjs/PhoneInputNativeDefaultMetadata.js
// module id = 784
// module chunks = 0